// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./defaultTheme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./core/icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./core/windowFrame.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./core/formElements.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./font-finance.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./fonts/Open_Sans/OpenSans-Definition.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./shared/common.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * finsemble.css
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */

.hidden {
	/* stylelint-disable-next-line declaration-no-important */
	display: none !important;
}

.flex-start {
	align-self: flex-start;
}

/* Gives the control icons the proper width on websites using bootstrap. */

i,
i::before,
i::after,
.fsbl-window-manager-icon {
	box-sizing: content-box;
}

body {
	font-weight: var(--font-weight);
	font-family: var(--font-family);
	color: var(--font-color);
	font-size: var(--font-size);
	background: var(--core-primary-1);
}
`, "",{"version":3,"sources":["webpack://./src/ui/assets/css/finsemble.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAUF;CACC,yDAAyD;CACzD,wBAAwB;AACzB;;AAEA;CACC,sBAAsB;AACvB;;AAEA,0EAA0E;;AAE1E;;;;CAIC,uBAAuB;AACxB;;AAEA;CACC,+BAA+B;CAC/B,+BAA+B;CAC/B,wBAAwB;CACxB,2BAA2B;CAC3B,iCAAiC;AAClC","sourcesContent":["/*!\n * finsemble.css\n * Copyright 2017 - 2020 by ChartIQ, Inc.\n * All rights reserved.\n */\n\n@import url(\"./defaultTheme.css\");\n@import url(\"core/icons.css\");\n@import url(\"core/windowFrame.css\");\n@import url(\"core/formElements.css\");\n@import url(\"./font-finance.css\");\n@import url(\"./fonts/Open_Sans/OpenSans-Definition.css\");\n@import url(\"./shared/common.css\");\n\n.hidden {\n\t/* stylelint-disable-next-line declaration-no-important */\n\tdisplay: none !important;\n}\n\n.flex-start {\n\talign-self: flex-start;\n}\n\n/* Gives the control icons the proper width on websites using bootstrap. */\n\ni,\ni::before,\ni::after,\n.fsbl-window-manager-icon {\n\tbox-sizing: content-box;\n}\n\nbody {\n\tfont-weight: var(--font-weight);\n\tfont-family: var(--font-family);\n\tcolor: var(--font-color);\n\tfont-size: var(--font-size);\n\tbackground: var(--core-primary-1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
